import React, { useEffect, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { QRCodeSVG } from "qrcode.react";
import axios from "axios";
import PuffLoader from "react-spinners/PuffLoader";
import { css } from "@emotion/react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Switch, Case } from "react-if";

const override = css`
  display: block;
  margin: auto;
  margin-top: 50px;
  border-color: red;
`;

const Deposit = ({ setShowDepositForm }) => {
  const address = useSelector((state) => state.address.value);
  const [loading, setLoading] = useState(true);
  const [depositAddressInfo, setDepositAddressInfo] = useState(null);

  function createDepositAddress() {
    setLoading(true);
    setDepositAddressInfo(null);

    axios
      .post("api/createDepositAddress", {
        address: address,
      })
      .then((res) => {
        console.log(res.data);
        getDepositAddress();
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  }

  const getDepositAddress = useCallback(async () => {
    setLoading(true);
    axios
      .post("api/getDepositAddress", {
        address: address,
      })
      .then((res) => {
        console.log(">>>>>>>>>>> data: ", res.data);

        setDepositAddressInfo(res.data);

        if (res.data.status === "WAIT") {
          setTimeout(() => {
            getDepositAddress();
          }, 5000);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          console.log(err.response);
        }
      });
  }, [setLoading, setDepositAddressInfo, address]);

  useEffect(() => {
    getDepositAddress();
  }, [getDepositAddress]);

  function Loading() {
    return <PuffLoader color="#fff" loading={true} css={override} size={100} />;
  }

  return (
    <div className="modal-body">
      <h2 className="mb-3">Deposit</h2>

      <div>
        {loading && !depositAddressInfo ? (
          <Loading></Loading>
        ) : (
          <Switch>
            <Case
              condition={
                depositAddressInfo && depositAddressInfo.status === "NONE"
              }
            >
              <div className="buttons">
                <button
                  className="w-100 btn btn-lg btn-primary pt-3 pb-3"
                  onClick={() => createDepositAddress()}
                >
                  Create deposit address
                </button>
                <button
                  className="w-100 btn btn-lg btn-secondary mt-3 pt-3 pb-3"
                  onClick={() => setShowDepositForm(false)}
                >
                  close
                </button>
              </div>
            </Case>
            <Case
              condition={
                depositAddressInfo && depositAddressInfo.status === "WAIT"
              }
            >
              <Loading></Loading>
              <div className="help">Creating a wallet for deposit.</div>
            </Case>
            <Case
              condition={
                depositAddressInfo && depositAddressInfo.status === "FAIL"
              }
            >
              <Loading></Loading>
              <div className="help">
                An error occurred while creating a wallet for deposit.
              </div>
            </Case>

            <Case
              condition={
                depositAddressInfo && depositAddressInfo.status === "SUCCESS"
              }
            >
              <div className="qrcode">
                <div className="help text-left">
                  Please send CRETA to the polygon wallet below. Please note
                  that any amount below decimal will be eliminated during
                  deposit.
                </div>

                <div>
                  <QRCodeSVG value={depositAddressInfo.address} />
                </div>

                <div className="address">{depositAddressInfo.address}</div>
              </div>

              <div className="w-100 flex-space-between mt-3">
                <button
                  className="btn btn-md btn-secondary"
                  onClick={() => setShowDepositForm(false)}
                >
                  close
                </button>
                <CopyToClipboard
                  text={depositAddressInfo.address}
                  onCopy={() => alert("Copied! ")}
                >
                  <button className="btn btn-md btn-primary">
                    Copy to clipboard
                  </button>
                </CopyToClipboard>
              </div>
            </Case>
          </Switch>
        )}
      </div>
    </div>
  );
};

export default Deposit;
